import SyosBtnViewKeyCommands from './SyosBtnViewKeyCommands';
import SyosUiContainer from './SyosUiContainer';
import type SyosController from './SyosController';
import type ViewportZoomControl from './utils/ViewportZoomControl';

class SyosMapControlsList extends SyosUiContainer {
  btnViewKeyCommands: SyosBtnViewKeyCommands;

  constructor(syosController: SyosController, zoomControl: ViewportZoomControl) {
    super(syosController, '.tn-syos-map-controls-list__container');

    this.$el.html(`<div class="${SyosBtnViewKeyCommands.MobileContainerClassName}"></div>`);

    this.btnViewKeyCommands = new SyosBtnViewKeyCommands(syosController, `.${SyosBtnViewKeyCommands.MobileContainerClassName}`);

    this.$el.append(zoomControl.$el);
  }

  destroy() {
    this.btnViewKeyCommands.destroy();

    super.destroy();
  }
}

export default SyosMapControlsList;
